import React from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../../AbstractElements';
import PagiNations from './PagiNations';
import PaginationActiveDisabled from './PaginationActiveDisabled';
import PaginationAlignment from './PaginationAlignment';
import PaginationWithIcons from './PaginationWithIcons';
import PaginationSizingClass from './PaginationSizing';
import PaginationColorClass from './PaginationColor';

const PaginationsContainer = () => {
  return (
    <Container fluid={true}>
      <Breadcrumbs pageTitle='Pagination' parent='Bonus Ui' title='Pagination' />
      <Row>
        <PagiNations />
        <PaginationWithIcons />
        <PaginationActiveDisabled />
        <PaginationAlignment />
        <PaginationSizingClass />
        <PaginationColorClass />
      </Row>
    </Container>
  );
};

export default PaginationsContainer;
